import useQuery from "hooks/useQuery";
import queryString from "query-string";
import { getComprobantesSinCAE } from "./api";

const useComprobantesSinCAE = () => {
  const { data, refetch, loading } = useQuery({
    autoFetch: false,
    queryFn: getComprobantesSinCAE,
  });

  const fetch = (params) => {
    const query = queryString.stringify(params);
    refetch(query);
  };

  return {
    comprobantes: data?.data?.comprobantes_sin_cae || [],
    fetch,
    loading,
  };
};

export default useComprobantesSinCAE;